import Svg from '@rexlabs/icons/medium/chevron-left.svg';
export default Svg;
